import { render, staticRenderFns } from "./BaseGoodsInfo.vue?vue&type=template&id=094eef2b&scoped=true&"
import script from "./BaseGoodsInfo.vue?vue&type=script&lang=js&"
export * from "./BaseGoodsInfo.vue?vue&type=script&lang=js&"
import style0 from "./BaseGoodsInfo.vue?vue&type=style&index=0&id=094eef2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094eef2b",
  null
  
)

export default component.exports